import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import type { CourseData } from '../types';
import { apiRequest } from './utils/apiClient';

export const locationsApi = {
  getAllUserLocations: async (callback: (res: CourseData) => void): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/users/locations/`;

    try {
      const data = await apiRequest<CourseData>({
        url,
        isAuth: false,
        method: 'GET',
      });

      callback(data);
    } catch (error) {
      logError('Error fetching user locations', error);
    }
  },
};
